import { Colors, Shadows } from '@ab-core/colors';
import { FontTypes } from '@ab-core/font-types';
import { RADIUS } from '@ab-core/radius';
import { Z_INDEX } from '@ab-core/z-index';
import styled from 'styled-components';

export const Wrapper = styled.div`
    gap: 1rem;
    display: flex;
    align-content: center;
    align-items: center;

    .ab-labelSlider {
        font-weight: ${FontTypes.body.fontWeight};
        font-size: ${FontTypes.body.fontSize};
        letter-spacing: ${FontTypes.body.letterSpacing};
        text-transform: ${FontTypes.body.textTransform};
    }
`;

export const SwitchContainer = styled.div`
    position: relative;
    display: inline-block;
    min-width: 2rem;
    width: 2rem;
    height: 1rem;

    .ab-switch {
        cursor: pointer;
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        margin: 0;
        padding: 0;
        z-index: ${Z_INDEX.BASE};
        &:disabled {
            cursor: not-allowed;
        }
        &:checked ~ .ab-slider {
            background-color: ${Colors.primaryLightenOne};
        }
        &:disabled ~ .ab-slider {
            background-color: ${Colors.gray30};
        }
        &:disabled:checked ~ .ab-slider {
            background-color: ${Colors.primaryLightenOne};
        }
    }
    .ab-slider {
        position: absolute;

        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: ${RADIUS.FULL};
        height: 1rem;

        background-color: ${Colors.gray50};
        &::before {
            position: absolute;
            content: ' ';
            height: 20px;
            width: 20px;

            border: 0.5px solid ${Colors.gray15};
            border-radius: ${RADIUS.CIRCLE};
            box-shadow: ${Shadows.componentShadow};

            left: 0;
            bottom: -2px;
            background-color: white;
            transition: 0.4s;
        }
    }

    .ab-switch:checked + .ab-slider::before {
        transform: translateX(0.75rem);
        background-color: ${Colors.primary};
        border: 0.5px solid ${Colors.primary};
    }

    .ab-switch:checked:disabled + .ab-slider::before {
        transform: translateX(0.75rem);
        background-color: ${Colors.primaryLightenTwo};
        border: 0.5px solid ${Colors.primaryLightenTwo};
    }
    .ab-switch:disabled + .ab-slider::before {
        background-color: ${Colors.gray15};
        border: 0.5px solid ${Colors.gray30};
    }
`;
